/**
 * ColumnsSelector Component
 * Allows selecting 1, 2, or 3 columns for grid layout
 */

import React from 'react';
import clsx from 'clsx';
import type { ColumnsSelectorProps } from './types';

export const ColumnsSelector: React.FC<ColumnsSelectorProps> = ({
  currentColumns,
  availableColumns,
  onChange,
  disabled = false,
}) => {
  if (availableColumns.length <= 1 || disabled) {
    return null; // Don't show if only one option or disabled
  }

  return (
    <div className="ai360-columns-selector">
      <span className="ai360-columns-selector-label">Columnas:</span>
      <div className="ai360-columns-selector-buttons">
        {availableColumns.map((cols) => (
          <button
            key={cols}
            type="button"
            className={clsx(
              'ai360-columns-selector-button',
              currentColumns === cols && 'ai360-columns-selector-button--active',
              disabled && 'ai360-columns-selector-button--disabled'
            )}
            onClick={() => !disabled && onChange(cols)}
            disabled={disabled}
            title={`${cols} columna${cols > 1 ? 's' : ''}`}
            aria-label={`${cols} columna${cols > 1 ? 's' : ''}`}
          >
            {cols}
          </button>
        ))}
      </div>
    </div>
  );
};
